<template>
  <div :class="classObj" class="app-wrapper">
    <div :class="{
      // hasTagsView:needTagsView,
      'main-container':false}" class="main-container-content">
      <div :class="{'fixed-header':fixedHeader}">
        <headbar />
        <!-- <tags-view v-if="needTagsView" /> -->
      </div>
      <div class="content-container">
        <leftMain></leftMain>  
        <app-main />
      </div>
     
      <!-- <right-panel v-if="showSettings">
        <settings />
      </right-panel> -->
    </div>
  </div>
</template>

<script>
import RightPanel from '@/components/RightPanel'
import { 
  AppMain, 
  Settings,
  Headbar, 
  Sidebar, 
  // TagsView 
} from './components'
import leftMain from './components/leftMain.vue'

import { mapState } from 'vuex'

export default {
  name: 'Layout',
  components: {
    AppMain,
  
    RightPanel,
    Settings,
    Sidebar,
    Headbar,
    // TagsView,
    leftMain
  },

  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader,
      
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 1366px;
    overflow-x: auto;
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .main-container-content{
    height: 100%;
    min-width: 1366px;
    overflow-x: auto;
  }
  .content-container{
    display: flex;
    height:calc(100% - 56px);
  }

</style>
